import React from 'react';


export const markerInfoStyle={
    marginTop: '1em',
    height: "90vh",  
    backgroundColor: '#FFFFFF',
    borderRadius: "0.25rem",
    boxShadow: " 0 20px 40px -14px rgba(0, 0, 0, 0.25)",
}
export const mapContainerStyle={
    height: "90vh",
    marginTop:'1em',
    boxShadow: '0 1px 4px 0 grey',
    borderRadius: '0.2em',
    marginRight: '10px',
}
export const flexMapContainerStyle={
    height: "86vh",
    marginTop:'1em',
    // boxShadow: '0 1px 4px 0 grey',
    // borderRadius: '0.2em',
    marginRight: '10px',
}
export const mapStyleBefore={
    height: "90%",
    width:  "calc(75% - 30px)",  
    marginTop:'1em',
    boxShadow: '0 1px 4px 0 grey',
    borderRadius: '0.2em'
}
export const mapStyleAfter={
    height: "90%",
    width: "98%",
    marginTop:'1em',
    boxShadow: '0 1px 4px 0 grey',
    borderRadius: '0.2em'
}

export const gridContainerStyle={
    width: '98%%',
    height: '80%',
    display: 'flex',
    flexWrap: 'wrap',
    boxSizing: 'border-box',
    flexDirection: 'row',
    alignItems: 'flex-start',
}

export const mainDropDownStyle={
    width: '100%',
    height: '65px',
    display: 'flex',
    flexWrap: 'wrap',
    boxSizing: 'border-box',
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginLeft: "15px",
    marginRight: "15px",
}

export const mainMapStyle={
    width: '100%',
    height: 'calc(100%-70px)',
    display: 'flex',
    flexWrap: 'wrap',
    boxSizing: 'border-box',
    flexDirection: 'row',
    alignItems: 'flex-start',
}

export const mainPageMapStyle={
    height: '100vh',
    display: 'block'
}

export const displayDataGrid={
    display: 'flex',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    justifyContent: 'space-between'
}
export const noDisplayDataGrid={
    display: 'none',
    
}